document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (evt) {
    var submitButton = evt.target.closest('.js-ajax-cart-form [type="submit"]');
    if (!submitButton) return;

    var form = submitButton.closest('.js-ajax-cart-form');
    if (!form) return;

    evt.preventDefault();

    if (submitButton.disabled) return;

    var originalLabel = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.classList.add('btn--loading');

    var cartAddUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart.');
        }
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(function (error) {
        console.error(error);
        form.submit();
      })
      .finally(function () {
        submitButton.disabled = false;
        submitButton.classList.remove('btn--loading');
        submitButton.textContent = originalLabel;
      });
  });
});
